var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeft = function SvgLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.087 2.081 3.058 7.052l4.97 5.03-1.01 1.993-6.96-7.04 7.04-6.96z"
  })));
};
export { SvgLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDkgMTUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04LjA4NjkyIDIuMDgxMjZMMy4wNTc5NSA3LjA1MjEzTDguMDI4ODIgMTIuMDgxMUw3LjAxNzIxIDE0LjA3NTNMMC4wNTgwMDM4IDcuMDM0NjlMNy4wOTg1NiAwLjA3NTQ4NjJMOC4wODY5MiAyLjA4MTI2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+";